/**
 * Done. / ChiroCPD — useAuth Hook
 *
 * Reads from AuthContext. Throws if used outside AuthProvider.
 * Convenience hook so components don't import context directly.
 */

import { useAuthContext } from '@/contexts/AuthContext';
import type { User, SubscriptionStatus } from '@/lib/types';

export interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  subscriptionStatus: SubscriptionStatus | null;
  professionId: string | null;
  refreshAuth: () => Promise<void>;
  clearAuth: () => void;
}

export function useAuth(): AuthState {
  return useAuthContext();
}
